/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import common from './common';

const pitrho = {
  dark: {
    background: {
      default: '#15181e',
      paper: '#28313a',
      header: '#282828',
    },
  },
  light: {
    background: {
      default: common.white,
      paper: common.white,
      header: '#08498A',
    },
  },
};

export default pitrho;
